module.exports = __webpack_public_path__ + "static/media/ig.239568a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ig.png
// module id = 247
// module chunks = 0